import { Outlet, RouteObject } from 'react-router-dom';
import { AllSignals } from 'components/pages/all-signals';
import { AllSignalsListView } from 'components/pages/all-signals/list-view';
import { ROUTE_PATHS } from './route-paths';

export const allSignalsRoutes: RouteObject = {
  path: '/',
  element: <Outlet />,
  children: [
    {
      // index: true,
      path: ROUTE_PATHS.ALL_SIGNALS,
      caseSensitive: true,
      element: <AllSignals />,
    },
    {
      path: `${ROUTE_PATHS.ALL_SIGNALS}/${ROUTE_PATHS.LIST}`,
      caseSensitive: true,
      element: <AllSignalsListView />,
    },
  ],
};
